




import { Component, Prop } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import StatusDisplayLocation from '@/models/Shared/StatusDisplayLocation';
import OpportunityStage, { OpportunityStageLabels } from '@/models/Opportunities/OpportunityStage';

@Component({ name: 'OpportunityStage' })
export default class extends GiganautVue {
    @Prop({ required: true }) stage!: OpportunityStage;
    @Prop({ required: true }) location!: StatusDisplayLocation;

    get text(): string {
        return (OpportunityStageLabels[this.stage] || 'Unknown').toUpperCase();
    }

    get color(): string {
        switch (this.stage) {
            case OpportunityStage.New: return 'grey';
            case OpportunityStage.Qualified: return 'blue';
            case OpportunityStage.Proposing: return 'indigo';
            case OpportunityStage.Negotiating: return 'orange';
            case OpportunityStage.Won: return 'green';
            case OpportunityStage.Lost: return 'red';
            default: return 'grey';
        }
    }

    get classy() {
        const classes: string[] = [];
        if (this.location !== StatusDisplayLocation.Grid) {
            classes.push('ma-1');
        }
        classes.push('overline');
        return classes;
    }
}
